// extracted by mini-css-extract-plugin
module.exports = {"pagBtn":"paginationBtn_pagBtn__wQnP7"};